import React, { Component, Fragment } from "react";

export default class Select extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
            aplicationName: "Select",
        }
        
    }

    render() {
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            {/* <label>Mês: </label> */}
                            <select name="modalidade" onChange={this.props.selectMes} className="form-control" value={this.props.mes} required>
                                {/* <option hidden>Selecione um mês</option> */}
                                <option value="Anual">Anual</option>
                                <option value="0">Janeiro</option>
                                <option value="1">Fevereiro</option>
                                <option value="2">Março</option>
                                <option value="3">Abril</option>
                                <option value="4">Maio</option>
                                <option value="5">Junho</option>
                                <option value="6">Julho</option>
                                <option value="7">Agosto</option>
                                <option value="8">Setembro</option>
                                <option value="9">Outubro</option>
                                <option value="10">Novembro</option>
                                <option value="11">Dezembro</option>
                            </select>
                        </div>
                    </div>
                </div>
                {/*<option key={modalidades.cr} value={[modalidades.modalidade, modalidades.cr]}>{modalidades.modalidade}</option>*/}
            </Fragment>
        )
    }

}
